import {useGlobalState} from 'hooks/useGlobalState';

import AddBeers from './AddBeers/AddBeers';
import ListBeers from './ListBeers/ListBeers';
import ManageBeers from './ManageBeers/ManageBeers';
import {beerManagerModes} from './typescript';

import './BeersManager.scss';

const BeersManager = () => {
  const {mode} = useGlobalState((state) => state.beersManager);

  const modes = {
    [beerManagerModes.listBeers]: <ListBeers />,
    [beerManagerModes.addBeers]: <AddBeers />,
    [beerManagerModes.manageBeers]: <ManageBeers />,
  };

  return <>{modes[mode]}</>;
};

export default BeersManager;
